/**
 * Contact properties sent to HubSpot, keyed by their internal name.
 */
interface HubspotContact {
    email: string;
    firstname?: string;
    lastname?: string;
    /** The pharmacy name. */
    company?: string;
}

const HubspotService = () => {
    /**
     * Tie the HubSpot visitor to the signed-in user, so the support inbox
     * shows who is writing. The identity only reaches HubSpot with the next
     * tracked page view, hence the `trackPageView` right after.
     *
     * Must receive a real email: HubSpot would link every visitor identified
     * with a placeholder to that single contact.
     *
     * Missing values are left out, so they never wipe what the contact record
     * holds.
     */
    const identify = (contact: HubspotContact) => {
        const properties = Object.fromEntries(Object.entries(contact).filter(([, value]) => value));

        window._hsq = window._hsq || [];
        window._hsq.push(['identify', properties]);
        window._hsq.push(['trackPageView']);
    };

    return {
        identify,
    };
};

export default HubspotService();
